import { CustomFieldType, MultipleChoiceConfigOptions } from '@shared/enums/CustomFieldType';
import { SelectFormat } from '@shared/enums/SelectFormat';
import { DateTimeRange } from './eventpage-model';

export interface IRegistration {
    id: string;
    invitationId: string;
    firstName: string;
    lastNamePrefix: string;
    lastName: string;
    email: string;
    mobile: string;
    companyName: string;
    addressLineOne: string;
    addressLineTwo: string;
    city: string;
    postalCode: string;
    country: string;
    guests: IGuest[];
    customFields: (IAddCustomFieldOption | IAddCustomField | IAddCustomFieldFile)[];
    locationDateTimeId: string;
    overBookingType: number;
    jobTitle: string;
    customerNumber: string;
    sendConfirmationMail: boolean;
}

export class Registration implements IRegistration {
    constructor(
        public id: string,
        public invitationId: string,
        public firstName: string,
        public lastNamePrefix: string,
        public lastName: string,
        public email: string,
        public mobile: string,
        public companyName: string,
        public addressLineOne: string,
        public addressLineTwo: string,
        public city: string,
        public postalCode: string,
        public country: string,
        public guests: IGuest[],
        public customFields: (IAddCustomFieldOption | IAddCustomField | IAddCustomFieldFile)[],
        public locationDateTimeId: string,
        public overBookingType: number,
        public jobTitle: string,
        public customerNumber: string,
        public sendConfirmationMail: boolean
    ) { }
}

export interface IGuest {
    id: string;
    parentId: string;
    isAnonymous: boolean;
    firstName: string;
    lastNamePrefix: string;
    lastName: string;
    email: string;
    mobile: string;
    companyName: string;
    addressLineOne: string;
    addressLineTwo: string;
    city: string;
    postalCode: string;
    country: string;
    customFields: (IAddCustomFieldOption | IAddCustomField | IAddCustomFieldFile)[];
    jobTitle: string;
    customerNumber: string;
    locationDateTimeId: string;
}

export class Guest implements IGuest {
    constructor(
        public id: string,
        public parentId: string,
        public isAnonymous: boolean,
        public firstName: string,
        public lastNamePrefix: string,
        public lastName: string,
        public email: string,
        public mobile: string,
        public companyName: string,
        public addressLineOne: string,
        public addressLineTwo: string,
        public city: string,
        public postalCode: string,
        public country: string,
        public customFields: (IAddCustomFieldOption | IAddCustomField)[],
        public jobTitle: string,
        public customerNumber: string,
        public locationDateTimeId: string
    ) { }
}

export interface IAddCustomField {
    id: string;
    contactCustomFieldId: string;
    textValue: string;
    numberValue: number;
    dateTimeValue: Date;
    booleanValue: boolean;
    customFieldType: CustomFieldType;
}

export class AddCustomField implements IAddCustomField {
    constructor(
        public id: string,
        public contactCustomFieldId: string,
        public textValue: string,
        public numberValue: number,
        public dateTimeValue: Date,
        public booleanValue: boolean,
        public customFieldType: CustomFieldType,
    ) { }
}

export interface IAddCustomFieldOption {
    id: string;
    contactCustomFieldId: string;
    customFieldOptions: ICustomFieldOptions[];
    customFieldType: CustomFieldType;
    textValue?: string;
}

export class AddCustomFieldOption implements IAddCustomFieldOption {
    constructor(
        public id: string,
        public contactCustomFieldId: string,
        public customFieldOptions: ICustomFieldOptions[],
        public customFieldType: CustomFieldType,
    ) { }
}

export interface IAddCustomFieldFile {
    id: string;
    contactCustomFieldId: string;
    customFieldFiles: ICustomFieldFile[];
    customFieldType: CustomFieldType;
    textValue?: string;
}

export class AddCustomFieldFile implements IAddCustomFieldFile {
    constructor(
        public id: string,
        public contactCustomFieldId: string,
        public customFieldFiles: ICustomFieldFile[],
        public customFieldType: CustomFieldType,
    ) { }
}

export interface ICustomField {
    id: string;
    contactCustomFieldId: string;
    translations: ICustomFieldTranslation[];
    show: boolean;
    showGuest: boolean;
    required: boolean;
    requiredGuest: boolean;
    customFieldType: CustomFieldType;
    customFieldOptions: ICustomFieldOptions[];
    customFieldOptionsExtraGuest: ICustomFieldOptions[];
    multipleChoiceConfigOptions: MultipleChoiceConfigOptions;
    selectFormat: SelectFormat;
}

export interface ICustomFieldTranslation {
    value: string;
    isDefault: boolean;
    languageId: string;
}

export interface IFieldRequiredProperty {
    name: string;
    value: string;
}

export interface ICustomFieldOptions {
    id: string;
    contactCustomFieldOptionId: string;
    translations: ICustomFieldOptionsTranslation[];
    timeSlot: DateTimeRange;
}

export interface ICustomFieldOptionsTranslation {
    id: string;
    value: string;
    isDefault: boolean;
    languageId: string;
}

export interface ICustomFieldFile {
    blobName: string;
    fileName: string;
}
